import React from "react";
import { Badge } from "react-bootstrap";
import dayjs from "dayjs";

const STATUS_CONFIG = {
  ACTIVE: { label: "Activo", bg: "success" },
  CLOSED: { label: "Cerrado", bg: "secondary" },
  INTERRUPTED: { label: "Interrumpido", bg: "warning" },
};

function CycleItem({ cycle }) {
  const { cycle_number, first_class_date, last_class_date, months_completed, status } =
    cycle;
  const { label, bg } = STATUS_CONFIG[status] ?? { label: status, bg: "secondary" };

  return (
    <div className="d-flex align-items-start gap-3 mb-3">
      <div className="text-center" style={{ minWidth: 36 }}>
        <div className="fw-bold text-primary">#{cycle_number}</div>
      </div>
      <div className="flex-grow-1">
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span className="fw-semibold">Ciclo {cycle_number}</span>
          <Badge bg={bg}>{label}</Badge>
          <span className="text-muted small">
            {months_completed} mes{months_completed !== 1 ? "es" : ""}
          </span>
        </div>
        <div className="text-muted small mt-1">
          {first_class_date && (
            <span>
              Inicio: {dayjs(first_class_date).format("DD/MM/YYYY")}
            </span>
          )}
          {last_class_date && (
            <span className="ms-3">
              Última: {dayjs(last_class_date).format("DD/MM/YYYY")}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

function CycleTimeline({ cycles, leadingStat }) {
  if (!cycles) return null;

  const { current, history = [], total_cycles, total_months } = cycles;

  return (
    <div>
      <div className="d-flex gap-4 mb-4 flex-wrap align-items-start">
        {leadingStat && (
          <div className="text-center pe-4 me-2 border-end">
            <div className="fs-4 fw-bold text-primary">{leadingStat.value}</div>
            <div className="text-muted small">{leadingStat.label}</div>
          </div>
        )}
        <div className="text-center">
          <div className="fs-2 fw-bold text-primary">{total_cycles}</div>
          <div className="text-muted small">ciclos</div>
        </div>
        <div className="text-center">
          <div className="fs-2 fw-bold text-primary">{total_months}</div>
          <div className="text-muted small">meses totales</div>
        </div>
      </div>

      {current && (
        <div className="mb-3">
          <h6 className="text-uppercase text-muted small mb-2">
            Ciclo actual
          </h6>
          <CycleItem cycle={current} />
        </div>
      )}

      {history.length > 0 && (
        <div>
          <h6 className="text-uppercase text-muted small mb-2">Histórico</h6>
          {history.map((c) => (
            <CycleItem key={c.cycle_number} cycle={c} />
          ))}
        </div>
      )}
    </div>
  );
}

export { CycleTimeline };
